module.exports = __webpack_public_path__ + "static/media/performing.8c2bf279.png";